import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4236fcd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "card-global flex items-center justify-between" }
const _hoisted_3 = { class: "page-title mb-0" }
const _hoisted_4 = { class: "mt-2 text-sm text-gray-500" }
const _hoisted_5 = { class: "flex gap-3" }
const _hoisted_6 = { class: "card-global" }
const _hoisted_7 = { class: "grid grid-cols-1 gap-6 md:grid-cols-2" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-500" }, "ID", -1))
const _hoisted_10 = { class: "text-sm text-gray-500" }
const _hoisted_11 = { class: "text-sm text-gray-500" }
const _hoisted_12 = { class: "mt-1 whitespace-pre-line text-gray-800" }
const _hoisted_13 = {
  key: 0,
  class: "card-global"
}
const _hoisted_14 = { class: "block-title" }
const _hoisted_15 = { class: "space-y-3" }
const _hoisted_16 = { class: "font-medium text-gray-900" }
const _hoisted_17 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_18 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_19 = {
  key: 0,
  class: "mt-2 text-sm text-gray-700"
}
const _hoisted_20 = { class: "card-global" }
const _hoisted_21 = { class: "block-title" }
const _hoisted_22 = ["innerHTML"]

import BackButton from "@/components/common/BackButton.vue";
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useToast } from "vue-toastification";
import { Button } from "@/components/common";
import StatusLabel from "@/components/common/StatusLabel.vue";
import PublicId from "@/components/common/PublicId.vue";
import { t } from "@/i18n";
import DocumentTemplateDataService from "@/services/documents/documentTemplate/DocumentTemplateDataService";
import FileDataService from "@/services/filemanager/files/FileDataService";
import DocumentTemplate from "@/types/documents/documentTemplate/DocumentTemplate";
import { ManualFieldType } from "@/types/documents/documentTemplate/ManualField";
import { formatDateTime } from "@/utils/date";
import { downloadPdf } from "@/utils/downloadPdf";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();
const toast = useToast();

const templateData = ref<DocumentTemplate | null>(null);
const pdfLoading = ref(false);

const wrappedTemplate = computed(() => {
  return (
    "<div style=\"font-family: 'Times New Roman', Times, serif;\">" +
    (templateData.value?.template || "") +
    "</div>"
  );
});

const manualFieldTypeLabel = (type: ManualFieldType["type"]) => {
  const labels: Record<ManualFieldType["type"], string> = {
    TEXTAREA: t("docTemplate.manualFieldType.textarea"),
    DATE: t("docTemplate.manualFieldType.date"),
    DATETIME: t("docTemplate.manualFieldType.datetime"),
    SELECT: t("docTemplate.manualFieldType.select"),
    MULTI_SELECT: t("docTemplate.manualFieldType.multiSelect"),
  };
  return labels[type] ?? type;
};

const loadTemplate = async () => {
  const response = await DocumentTemplateDataService.get(route.params.id);
  templateData.value = response.data.data;
};

const previewPdf = async () => {
  if (!templateData.value?.id) {
    return;
  }
  pdfLoading.value = true;
  try {
    const convertResponse = await DocumentTemplateDataService.convert({
      name: templateData.value.name || `template-${templateData.value.id}`,
      templateId: templateData.value.id,
      template: wrappedTemplate.value,
      footerEnabled: templateData.value.footerEnabled ?? false,
      footerScope: templateData.value.footerScope ?? "LAST_PAGE",
      footerHtml: templateData.value.footerHtml ?? "",
      footerHeightMm: templateData.value.footerHeightMm ?? 25,
      fieldConfig: [],
    });
    const fileGuid = convertResponse.data.data.fileGuid;
    const fileResponse = await FileDataService.downloadBlob(fileGuid);
    downloadPdf(
      fileResponse.data,
      templateData.value.name || `template-${templateData.value.id}`
    );
  } catch (error) {
    console.error(error);
    toast.error(t("docTemplate.details.pdfError"));
  } finally {
    pdfLoading.value = false;
  }
};

const goToEdit = () => {
  if (!templateData.value?.id) {
    return;
  }
  router.push({
    name: "DocumentTemplateEdit",
    params: { id: templateData.value.id },
  });
};

onMounted(loadTemplate);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'DocumentTemplateList' },
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(templateData.value?.name || _unref(t)("docTemplateList.title")), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("common.updatedAt")) + ": " + _toDisplayString(_unref(formatDateTime)(templateData.value?.updatedAt)), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(Button), {
            type: "button",
            onClick: previewPdf,
            disabled: pdfLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(pdfLoading.value ? "PDF..." : "PDF"), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_unref(Button), {
            type: "button",
            class: "bg-green-600",
            onClick: goToEdit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.edit")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (templateData.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(PublicId, {
                  value: templateData.value.id
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)("common.status")), 1),
            _createVNode(StatusLabel, {
              label: templateData.value?.status
            }, null, 8, ["label"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)("docTemplate.comment")), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(templateData.value?.comment || "—"), 1)
          ])
        ])
      ]),
      (templateData.value?.manualFields?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("h2", _hoisted_14, _toDisplayString(_unref(t)("docTemplate.manualFields.title")), 1),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templateData.value.manualFields, (field) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${field.tag}-${field.sortOrder}`,
                  class: "rounded border border-gray-200 p-4"
                }, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(field.name), 1),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)("docTemplate.manualFields.tag")) + ": " + _toDisplayString(field.tag), 1),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)("docTemplate.manualFields.fieldType")) + ": " + _toDisplayString(manualFieldTypeLabel(field.type)), 1),
                  (field.options?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(t)("docTemplate.details.options")) + ": " + _toDisplayString(field.options
                .map((option) => option.label || option.value)
                .join(", ")), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("h2", _hoisted_21, _toDisplayString(_unref(t)("docTemplate.details.content")), 1),
        _createElementVNode("div", {
          class: "document-template-preview min-h-[400px] rounded border border-gray-200 bg-white p-6",
          innerHTML: _unref(wrappedTemplate)
        }, null, 8, _hoisted_22)
      ])
    ])
  ], 64))
}
}

})